export const externalBaseUrl = 'https://external.forcemanager.net/external/v1';
